import { togaApiRequest } from "../../../api/toga";
import { ExtendedOptionsType } from "../../Items/api/itemsApi";

// This is the API call to get the order details
export async function getOrderDetails(internalId: string) {
	let options: ExtendedOptionsType = {
		fields: [
			"uuid",
			"salesOrderItems.uuid",
			"salesOrderItems.lineNumber",
			"salesOrderItems.item.partNumber",
			"salesOrderItems.item.skuNumber",
			"salesOrderItems.item.upcCode",
			"salesOrderItems.item.manufacturer.name",
			"salesOrderItems.item.description",
			"salesOrderItems.quantity",
			"salesOrderItems.item.inventoryType",
			"salesOrderItems.qtyCommitted",
			"salesOrderItems.price",
			"salesOrderItems._extPrice",
			"salesOrderItems._qtyBilled",
			"salesOrderItems._qtyFulfilled",
			"salesOrderItems.item._qtyTotal",
		],
		where: {
			and: [{ c_netsuiteInternalSalesOrderId: { "=": internalId } }],
		},
	};
	let response = await togaApiRequest("GET", "/sales-orders", null, options);
	return response.data;
}

//Check if SalesOrder Exists in toga database
export async function checkIfSalesOrderExists(internalId: string) {
	let options: ExtendedOptionsType = {
		fields: ["uuid"],
		where: {
			and: [{ c_netsuiteInternalSalesOrderId: { "=": internalId } }],
		},
	};
	let response = await togaApiRequest("GET", "/sales-orders", null, options);
	if (response.data.salesOrders.length > 0) {
		return true;
	} else {
		return false;
	}
}

export async function syncNetsuiteSalesOrderWithToga(internalId: string) {
	let response = await togaApiRequest(
		"GET",
		"/sales-orders/syncNetsuiteSalesOrder?netsuiteInternalSalesOrderId=" +
			internalId,
		null
	);
	if (!response.isSuccess) {
 		return;
	}
	return response.data;
}

export async function syncNetsuiteItemFulfillmentWithToga(internalId: string) {
	let response = await togaApiRequest(
		"GET",
		"/item-fulfillments/syncNetsuiteItemFulfillmentsForSalesOrder?netsuiteInternalSalesOrderId=" +
			internalId,
		null
	);
	if (!response.isSuccess) {
 		return;
	}
	return response.data;
}
